import { render, staticRenderFns } from "./kegiatan_csr.vue?vue&type=template&id=87e53fa4"
import script from "./kegiatan_csr.vue?vue&type=script&lang=js"
export * from "./kegiatan_csr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QSelect,QInput,QBtn,QTooltip,QImg,QChip,QSeparator,QCardActions,QPagination,QDialog,QEditor,QFile,QIcon,QList,QItem,QItemSection,QBadge,QToggle,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QSelect,QInput,QBtn,QTooltip,QImg,QChip,QSeparator,QCardActions,QPagination,QDialog,QEditor,QFile,QIcon,QList,QItem,QItemSection,QBadge,QToggle})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
